import React, { useState, useRef } from 'react';
import getCookie from '~/js/modules/includes/get-cookie';
import VerticalQQ from './verticalQQ';
import HorizontalQQ from './horizontalQQ';

const QQ = props => {
  const {
    className = '',
    onChange,
    rstCode = '',
    categoryCode = '',
    horizontal = false,
    horizontalSpecial = false,
    withFlightsId = ['with-flights', 'with-flights-1'],
    resortSelect,
    storeResortCode = false,
  } = props;

  const oldVacationData = useRef('');

  const savedRstCode = storeResortCode
    ? sessionStorage.getItem('rstCode')
    : null;

  const isResortAvailable =
    savedRstCode && resortSelect
      ? resortSelect?.resortOptions?.find(
          resortInfo =>
            resortInfo.code.toLowerCase() === savedRstCode.toLowerCase()
        )
      : false;

  const rstCodeValue =
    storeResortCode && isResortAvailable ? savedRstCode : rstCode;

  const [vacationData, setVacationData] = useState({
    referral: getCookie('COBRAND_COOKIE'),
    agentId: getCookie('COBRAND_AGENT'),
    rstCode: rstCodeValue,
    categoryCode: categoryCode,
    checkInDate: '',
    checkOutDate: '',
    gateway: '',
    seatType: 'economy',
    arrivalGateway: '',
  });

  const alignment =
    !horizontal && !horizontalSpecial ? 'vertical' : 'horizontal';

  const saveVacationData = el => {
    const newVacationData = { ...vacationData, ...el };

    oldVacationData.current = vacationData;
    setVacationData(newVacationData);
    onChange(newVacationData);
  };

  const activeABTest = sessionStorage.getItem('ABTestID');

  return (
    <div>
      {activeABTest === '1086047' && (horizontal || horizontalSpecial) && (
        <div
          className={`ssv-info-message ${
            vacationData.rstCode === 'SSV'
              ? 'show-item'
              : oldVacationData.current.rstCode === 'SSV'
              ? 'hide-item'
              : ''
          }`}
        >
          <div className="row">
            <div className="xs-12">
              <span>
                Best arrival + departure flights: USA: Mon, Wed, Sat. CANADA:
                Mon, Tue, Thu and Fri.
              </span>
            </div>
          </div>
        </div>
      )}
      <div className={`qq-wrapper ${alignment} ${className}`}>
        {!horizontal && !horizontalSpecial && (
          <VerticalQQ
            {...props}
            alignment={alignment}
            saveVacationData={saveVacationData}
            vacationData={vacationData}
            withFlightsId={withFlightsId}
          />
        )}
        {(horizontal || horizontalSpecial) && (
          <HorizontalQQ
            {...props}
            alignment={alignment}
            saveVacationData={saveVacationData}
            vacationData={vacationData}
            horizontalSpecial={horizontalSpecial}
            withFlightsId={withFlightsId}
          />
        )}
      </div>
    </div>
  );
};

export default QQ;
